import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientMedicalHistoryItem } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: PatientMedicalHistoryItem[] = [];

    for (const i in res.data) {
      const { _id, status, condition_origin, condition, date } = res.data[i];

      newData.push({
        id: _id,
        condition,
        origin: condition_origin?.toLocaleLowerCase(),
        status: status?.toLocaleLowerCase(),
        date: new Date(date),
      });
    }
    // console.log(newData);
    return newData.sort((a, b) => b.date.getTime() - a.date.getTime());
  }
  return null;
};

interface QueryProps {
  patientId: string;
}
export const useGetPatientMedicalHistory = ({ patientId }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientQKeys.medicalHistory(patientId),
    queryFn: () => api.get(`patient/conditions/${patientId}`),
    select,

    onError: (res: any) => {
      console.error("[From Get Patient Medical History]", res);
      handleErrors(res, "query");
    },
  });
};
